import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { MainService } from '../main/service/mainservice';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../components/login/service/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { DashboardService } from './dashboard.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import { DialogService } from '../../../services/dialog.service';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  private readonly notifier: NotifierService;
  myOptions: any;
  bodySpinner: boolean = false;
  allowedApps: any[] = [];
  allApps: any[] = [];
  isModalVisible: boolean = false;
  metricFullscreen: boolean = true;
  popLoader: boolean = false;
  listSearch: any = '';
  userListData: any[] = [];
  pageNo: number = 0;
  limit: number = 1000;
  userListPayload: any;
  total_pages: number = 0;
  userForm: FormGroup = new FormGroup({});
  userselectedId: any = null;
  modelType: string = '';
  submitted: boolean = false;
  initContry: any;
  roleList: any[] = [];
  spinner: boolean = false;
  countryCode2: any;
  countryCode1: any;
  loginedInRole: any;
  loginedUserDetails: any;
  formattedValue: any;
  initialCountryCode: any;
  userDetailInput: any;
  @ViewChild('intlInput') intlInput!: ElementRef;
  @ViewChild('phoneComp') phoneComp!: PhoneNumberInputComponent;
  constructor(
    private mainService: MainService,
    private fb: FormBuilder,
    private router: Router,
    private service: LoginService,
    private notifierService: NotifierService,
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private dialogService: DialogService,
  ) {
    this.bodySpinner = true;
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.dashboardService.getCurrentUser().subscribe({
      next: (response: any) => {
        this.allowedApps = response?.['apps'];
        this.allApps = response?.['all_apps'];
        this.loginedInRole = response['role'];
        if (this.loginedInRole == 'Admin') {
          this.getUserRoles();
        }
        this.loginedUserDetails = response;
        this.bodySpinner = false;
      },
      error: (errors: HttpErrorResponse) => {
        this.bodySpinner = false;
      },
    });

    this.userForm = this.fb.group({
      company_name: [''],
      location: [''],
      username: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9\s\/\&\-\'\.\_]*$/),
        ],
      ],
      first_name: [''],
      last_name: [''],
      middle_name: [''],
      email: [
        '',
        [
          Validators.required,
          ,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
      ],
      userid: [''],
      role: ['', Validators.required],
      doj: [''],
      empid: [''],
      phone_number: ['', [Validators.required]],
      password: [''],
      apps: ['', [Validators.required]],
    });

    this.myOptions = {
      placement: 'top',
      showDelay: 200,
      hideDelay: 0,
      maxWidth: 200,
      zIndex: 100000,
      trigger: 'hover',
      shadow: true,
    };

    this.pageNo++;
    this.userListPayload = {
      filters: [],
      page: this.pageNo,
      per_page: this.limit,
      sort_by: 'email',
      sort_order: 'desc',
    };
    // this.getUserList();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }

  selectedApps(data: any) {
    this.spinner = true;
    let appsList = [
      {
        text: 'Post Call Analytics and Process Automation',
        icon: 'bi bi-telephone',
        url: 'https://aiagentcall.canstringai.com/your-agents',
        name: 'SmartAIAgent',
      },
      {
        text: 'Post Call Analytics and Process Automation',
        icon: 'bi bi-telephone',
        url: '/main/postcall/audioRecords',
        name: 'audio',
      },
      {
        text: 'Voice Mail Analytics and Process Automation',
        icon: 'bi bi-soundwave',
        url: '/main/voiceMailRecords',
        name: 'voiceMail',
      },
      {
        text: 'IVR Analytics and Process Automation',
        icon: 'bi bi-telephone',
        url: '/main/ivrRecords',
        name: 'ivr',
      },
      {
        text: 'E-mail Analytics and Process Automation',
        icon: 'bi bi-envelope',
        url: '/main/email/autoEmailRecords',
        name: 'email',
      },
      {
        text: 'E-mail Analytics and Process Automation',
        icon: 'bi bi-envelope',
        url: '/main/emailAudit',
        name: 'emailAudit',
      },
      {
        text: 'Survey Analytics and Process Automation',
        icon: 'bi bi-clipboard-data',
        url: '/main/surveyRecords',
        name: 'survey',
      },
      {
        text: 'Text Analytics and Process Automation',
        icon: 'bi bi-clipboard-data',
        url: '/main/textRecords',
        name: 'text',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-file-earmark',
        url: '/main/doc-analytics',
        name: 'document',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-file-earmark',
        url: '/main/contracts',
        name: 'contract',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-file-earmark',
        url: '/main/rfpcontracts',
        name: 'rfpcontract',
      },
      {
        text: 'Document Analytics and Process Automation',
        icon: 'bi bi-shield-lock',
        url: '/main/infosecurity',
        name: 'infosecurity',
      },
      {
        text: 'AI Assistance',
        icon: 'bi bi-robot',
        url: 'https://gpt.absenceassistance.com',
        name: 'ai-assist',
      },
      {
        text: 'BI Dashboards and Reports',
        icon: 'bi bi-graph-up-arrow',
        url: 'https://bimatrix.canstringai.com/timebound',
        name: 'reports',
      },
    ];

      if (data == 'SmartAIAgent') {
      window.open('https://aiagentcall.canstringai.com/your-agents', 'target=_blank');
      return;
    }

    if(data=='Campaign'){
       window.open('https://aiagentcall.canstringai.com/campaigns', 'target=_blank');
      return;
    }

    if (data == 'ai-assist') {
      window.open('https://gpt.absenceassistance.com', 'target=_blank');
      return;
    }
    if (data == 'reports') {
      window.open(
        'https://bimatrix.canstringai.com/timebound',
        'target=_blank',
      );
      return;
    }
    

    if (data == 'social-media') {
      return;
    }
    let selected = appsList.filter((list) => list['name'] == data);
    this.router.navigateByUrl(selected[0]['url']);

    localStorage.setItem('selectedApps', selected[0]['name']);
    this.spinner = false;
    this.mainService.selectedAppsBS.next(selected[0]);
  }

  clearStorage() {
    let user: any = localStorage.getItem('user');

    var data = CryptoJS.AES.decrypt(user, this.service.enCryptKey).toString(
      CryptoJS.enc.Utf8,
    );
    let userDetails = JSON.parse(data);

    this.service.logout(userDetails['userid']).subscribe({
      next: (res: any) => {
        this.notifier.notify('default', 'You are successfully logged out');
        localStorage.clear();
        this.router.navigate(['login']);
      },
      error: (error: HttpErrorResponse) => {},
    });
  }

  isAllowed(appName: string) {
    if (this.allowedApps?.length > 0) {
      let index = this.allowedApps.findIndex(
        (list: any) => list['name'].toLowerCase() == appName.toLowerCase(),
      );
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  closeModal() {
    this.isModalVisible = false;
  }

  OpenModel(modal: string) {
    this.isModalVisible = true;
    this.userListData = [];
    this.getUserList();
  }

  getUserRoles() {
    this.dashboardService.getuserRoleList().subscribe((res: any) => {
      this.roleList = res;
    });
  }

  getUserList() {
    this.dashboardService.getUserList(this.userListPayload).subscribe({
      next: (response: any) => {
        this.userListData = [...response['data']];
        if (this.userListData.length > 0) {
          this.selectUser(this.userListData[0]);
        }
        this.total_pages = response['pagination']['total_pages'];
      },
      error: (errors: HttpErrorResponse) => {
        this.userListData = [];
      },
    });
  }

  searchUser() {
    this.userListPayload['filters'] = {
      property: 'username',
      operator: 'eq',
      value: this.listSearch,
    };

    this.getUserList();
  }

  selectUser(user: any) {
    this.userForm.patchValue({
      ...user,
      apps: user?.apps,
    });
    // this.initContry.setNumber(user?.phone_number);
    this.userForm.patchValue(user);
    this.userDetailInput = user;

    // let phoneNo = this.userForm.controls['phone_number'].value;
    // let countryCode = phoneNo.slice(0,3);
    //      let phone = phoneNo.slice(-10);
    // this.initContry.setNumber(phoneNo);
    if (user?.role == 'Admin') {
      this.userForm.get('role')?.disable();
      // this.userForm.get('apps')?.disable();
    } else {
      this.userForm.get('role')?.enable();
      this.userForm.get('apps')?.enable();
    }
    this.userselectedId = user['id'];
    this.modelType = 'edit';
  }

  onNearEndScroll() {
    if (this.pageNo < this.total_pages) {
      this.pageNo++;
      this.getUserList();
    }
  }

  newUser() {
    this.userForm.get('role')?.enable();
    this.userForm.get('apps')?.enable();
    this.submitted = false;
    this.userForm.reset();
    this.userselectedId = null;
    this.userForm.patchValue({ phone_number: '' });
    setTimeout(() => this.phoneComp.reset('US'));
  }

  onSubmit() {
    this.submitted = true;
    // const value = this.userForm.controls['phone_number'].value;
    //  this.countryCode2 = this.initContry.getSelectedCountryData().dialCode;
    // if (!value.includes('+91')) {
    //   this.userForm.controls['phone_number'].setValue(
    //     '+' +
    //       (this.countryCode2
    //         ? this.countryCode2
    //         : this.countryCode1
    //       ).toString() +
    //       this.userForm.controls['phone_number'].value
    //   );
    // }
    this.userForm.markAllAsTouched();
    this.userForm.markAsDirty();

    if (this.userForm.valid) {
      this.spinner = true;
      if (this.userselectedId == null) {
        this.dashboardService.addUser(this.userForm.value).subscribe({
          next: (response: any) => {
            this.spinner = false;
            this.notifier.notify('default', 'Created successfully');
            this.getUserList();
          },
          error: (errors: HttpErrorResponse) => {
            this.spinner = false;
          },
        });
      } else {
        const formObject = {
          username: this.userForm.value?.username,
          role: this.userForm.getRawValue()?.role, // getRawValue() to capture disabled controls
          email: this.userForm.value?.email,
          phone_number: this.userForm.value?.phone_number,
          apps: this.userForm.getRawValue()?.apps, // getRawValue() to capture disabled controls
          id: this.userselectedId,
        };
        this.dashboardService.updateUser(formObject).subscribe({
          next: (res: any) => {
            this.spinner = false;
            this.notifier.notify('default', 'Updated successfully');
            this.getUserList();
          },
          error: (errors: HttpErrorResponse) => {
            this.spinner = false;
          },
        });
      }
    }
  }

  pressCancel() {}

  ngAfterViewInit() {
    //   this.initContry = intlTelInput(this.intlInput.nativeElement, {
    //   allowDropdown: true,
    //   nationalMode: true,
    //   initialCountry: 'US',
    //   separateDialCode: false
    // });
    //  const countryData = this.initContry.getSelectedCountryData();
    // this.initialCountryCode=countryData.dialCode;
    // Add country change event listener
    // this.intlInput.nativeElement.addEventListener('countrychange', () => {
    //   const countryData = this.initContry.getSelectedCountryData();
    //   this.userForm.controls['phone_number'].setValue('+'+countryData.dialCode);
    //   // Handle country change here
    // });
    // this.renderer.listen(this.intlInput.nativeElement,'countrychange',(event:any)=>{
    //      const countryData = this.initContry.getSelectedCountryData();
    //      if(countryData?.dialCode) {
    //        this.userForm.controls['phone_number'].setValue('+'+countryData.dialCode);
    //      }
    // });
  }

  onInputPhoneChange(event: any) {
    if (event.target.value.length > 17) {
      event.preventDefault();
      let input = event.target.value;
      this.formattedValue = input.slice(0, 17);
      // this.userForm.controls['phone_number'].setValue(this.formattedValue);
    } else {
      // this.userForm.controls['phone_number'].setValue(event.target.value);
    }

    //   let input =event.target.value.replace(/[^\d+]/g, '');
    //     //  let input = event.target.value.replace(/\D/g, ''); // Remove non-digits

    // // Format: 123-456-7890
    //   if(input.length > 16){
    //     this.formattedValue = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}-${input.slice(10, 13)}-${input.slice(13, 16)}`;
    //   }
    //   if (input.length > 6) {
    //     this.formattedValue = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
    //   } else if (input.length > 3) {
    //     this.formattedValue = `${input.slice(0, 3)}-${input.slice(3)}`;
    //   } else {
    //     this.formattedValue = input;
    //   }

    //         this.userForm.controls['phone_number'].setValue(this.formattedValue);
  }

  deactivateUserFun(Userdata: any) {
    let formObject: any = {};
    if (Userdata.is_active) {
      this.dialogService.openConfirmDialog('', {
        title: 'Confirm',
        message: 'Are you sure you want to Deactivate this user?',
        btnOkText: 'Yes',
        btnCancelText: 'No',
        onClose: (data: any) => {
          if (data) {
            formObject['id'] = Userdata['id'];
            formObject['is_active'] = Userdata.is_active ? false : true;
            this.spinner = true;
            this.dashboardService.updateUser(formObject).subscribe({
              next: (response: any) => {
                this.spinner = false;
                this.notifier.notify('default', 'Updated successfully');
                this.userDetailInput['is_active'] = false;
              },
              error: (errors: HttpErrorResponse) => {
                this.spinner = false;
              },
            });
          }
        },
      });
    } else {
      this.dialogService.openConfirmDialog('', {
        title: 'Confirm',
        message: 'Are you sure you want to activate this user?',
        btnOkText: 'Yes',
        btnCancelText: 'No',
        onClose: (data: any) => {
          if (data) {
            formObject['id'] = Userdata['id'];
            formObject['is_active'] = Userdata.is_active ? false : true;

            this.spinner = true;
            this.dashboardService.updateUser(formObject).subscribe({
              next: (response: any) => {
                this.spinner = false;
                this.notifier.notify('default', 'Updated successfully');
                this.userDetailInput['is_active'] = true;
              },
              error: (errors: HttpErrorResponse) => {
                this.spinner = false;
              },
            });
          }
        },
      });
    }
  }

  deleteUserFun(userDetailInput: any) {
    this.dialogService.openConfirmDialog('', {
      title: 'Confirm',
      message: 'Are you sure you want to delete this user?',
      btnOkText: 'Yes',
      btnCancelText: 'No',
      onClose: (data: any) => {
        if (data) {
          this.dashboardService.deleteUser(userDetailInput['id']).subscribe({
            next: (response: any) => {
              this.notifier.notify('default', 'User deleted successfully');
              this.getUserList();
            },
            error: (erors: HttpErrorResponse) => {},
          });
        }
      },
    });
  }
}
